import { useSelector } from "react-redux";
import { selectPermissions, selectPermissionsLoading } from "Redux/Role/slice";
import { readObj } from "Service/storage";
import { canViewSetting, settingsEntries } from "./settingsCatalog";
export function useSettingsAccess() {
  const permissions = useSelector(selectPermissions);
  const loading = useSelector(selectPermissionsLoading);
  const account = readObj("account");
  const identity = { owner: !!(account?.contact?.is_owner || account?.is_owner), administrator: !!account?.contact?.is_administrator };
  return { permissions, identity, loading, entries: settingsEntries.filter(e => canViewSetting(e, permissions, identity)) };
}
